'use strict';

var SearchCriteriaConstantsService = function SearchCriteriaConstantsService() {
  return {
    MARKET_ANALYSIS: 'market-analysis',
    DASHBOARD: 'dashboard',
    FLIGHT_ANALYSIS: 'flight-analysis',
    FLIGHT_ANALYSIS_POST_DEPARTURE: 'flight-analysis-post-departure',
    STRATEGIES: 'strategies',
    SEASONALITY: 'seasonality',
    SYSTEM_STATUS_FLIGHT_SENT: 'system-status-flight-sent',
    SYSTEM_STATUS_SERVICE_SENT: 'system-status-service-sent',
    SYSTEM_STATUS_FLIGHT_REOPT: 'system-status-flight-reopt',
    SYSTEM_STATUS_MARKET_REOPT: 'system-status-market-reopt',
    SYSTEM_STATUS_FARES_REOPT: 'system-status-fares-reopt',
    SERVICE_STATUS_HISTORY_MARKET: 'system-status-history-market',
    SERVICE_STATUS_HISTORY_FLIGHT: 'system-status-history-flight',
    SERVICE_STATUS_HISTORY_SERVICE: 'system-status-history-service',
    SYSTEM_STATUS_INTERFACE_STATUS: 'system-status-interface-status',
    SYSTEM_CONFIGURATION_USER_DEFINED_REF_DATA_MARKET: 'system-conf-user-defined-ref-data-market',
    SYSTEM_CONFIGURATION_USER_DEFINED_REF_DATA_FLIGHT: 'system-conf-user-defined-ref-data-flight',
    SYSTEM_CONFIGURATION_MARKET_CLASS_FARE_MARKET: 'system-conf-market-class-fare',
    SYSTEM_CONFIGURATION_FARES_SURCHARGE_UPLOAD_FLIGHT: 'system-conf-surcharge',
    FARES: 'fares',
    ROM_ANALYSIS: 'rom-analysis',
    ROM_SUMMARY: 'rom-summary',
    RULES: 'rules',
    PRICING_ANALYSIS: 'pricing-analysis',
    PRICING_SUMMARY: 'pricing-summary',
    FARES_OPTIMIZER: 'fares-optimizer',
    FARES_OPTIMIZER_ANALYSIS: 'fares-optimizer-analysis',
    FO_SEARCH_MODES: {
      RETRIEVE_LAST_SNAPSHOT: 'retrieveLastSnapshot'
    },
    SEARCH_MODES: {
      POST_DEPARTURE: 'postDeparture'
    },
    CALIBRATION_ANALYSIS: 'calibration-analysis'
  };
};
SearchCriteriaConstantsService.$inject = [];
module.exports = SearchCriteriaConstantsService;